module.exports = __webpack_public_path__ + "img/reachme.1d7cd590.jpeg";